"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clockwise90DegreeRotationsFromUpright = exports.faceRotationLetterToClockwiseAngle = exports.FaceRotationLetterToClockwise90DegreeAngle = exports.FaceRotationLetterToClockwise90DegreeRotationsFromUpright = exports.FaceOrientationLetterTrblOrUnknown = exports.InvalidFaceOrientationLettersTrblOrUnknownException = exports.ValidFaceOrientationLetterTrblOrUnknown = exports.FaceOrientationLettersTrblOrUnknown = exports.FaceOrientationLetterTrbl = exports.InvalidFaceOrientationLettersTrblException = exports.ValidFaceOrientationLetterTrbl = exports.FaceOrientationLettersTrbl = exports.InvalidFaceRotationException = exports.FaceDigit = exports.FaceDigits = exports.InvalidFaceDigitException = exports.FaceLetter = exports.InvalidFaceLetterException = exports.FaceLetters = void 0;
/********************************************
 * FaceLetter
 ********************************************
 * An array of the 25 unique letters used to identify each die.
 */
exports.FaceLetters = [
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
];
const ValidFaceLetters = new Set(exports.FaceLetters);
class InvalidFaceLetterException extends Error {
    constructor(letter, { position } = {}) {
        super(`${letter} is not a valid die letter${position == null ? "" : ` at position ${position}`}.`);
        this.letter = letter;
        this.position = position;
    }
}
exports.InvalidFaceLetterException = InvalidFaceLetterException;
/**
 * Coerce a string to a FaceLetter, throwing an exception if the string is not a valid die letter.
 * @param letter The string which should contain an element letter
 * @param param1 Optional objected used to pass a position with a DiceKey for exception reporting
 */
const FaceLetter = (letter, { position } = {}) => {
    if (!ValidFaceLetters.has(letter))
        throw new InvalidFaceLetterException(letter, { position });
    return letter;
};
exports.FaceLetter = FaceLetter;
exports.FaceLetter.isValid = (couldBeLetter) => couldBeLetter != null && ValidFaceLetters.has(couldBeLetter);
/********************************************
 * FaceDigit
 ********************************************/
class InvalidFaceDigitException extends Error {
    constructor(digit, { position } = {}) {
        super(`${digit} (${typeof digit}) is not a valid element digit${position == null ? "" : ` at position ${position}`}.`);
        this.digit = digit;
        this.position = position;
    }
}
exports.InvalidFaceDigitException = InvalidFaceDigitException;
exports.FaceDigits = ["1", "2", "3", "4", "5", "6"];
const ValidFaceDigits = new Set(exports.FaceDigits);
const FaceDigit = (digitOrDigitString, { position } = {}) => {
    const faceDigitString = (typeof (digitOrDigitString) === "number") ?
        digitOrDigitString.toString() :
        digitOrDigitString;
    if (!ValidFaceDigits.has(faceDigitString)) {
        throw new InvalidFaceDigitException(digitOrDigitString, { position });
    }
    return faceDigitString;
};
exports.FaceDigit = FaceDigit;
exports.FaceDigit.isValid = (candidate) => candidate != null && ValidFaceDigits.has(candidate);
/********************************************
 * Clockwise90DegreeRotationsFromUpright and FaceRotationLetter
 ********************************************/
class InvalidFaceRotationException extends Error {
    constructor(rotation, { position } = {}) {
        super(`${rotation} is not a valid element rotation ${((typeof rotation) === "number") ?
            `(0, 1, 2, 3)` :
            `string ("t", "r", "b", or "l")`}${position == null ?
            "" :
            ` at position ${position}`}.`);
        this.rotation = rotation;
        this.position = position;
    }
}
exports.InvalidFaceRotationException = InvalidFaceRotationException;
exports.FaceOrientationLettersTrbl = ["t", "r", "b", "l"];
exports.ValidFaceOrientationLetterTrbl = new Set(exports.FaceOrientationLettersTrbl);
const isFaceOrientationLetterTrbl = (c) => exports.ValidFaceOrientationLetterTrbl.has(c);
class InvalidFaceOrientationLettersTrblException extends Error {
    constructor(orientationAsLowercaseLetterTRBL, { position } = {}) {
        super(`${orientationAsLowercaseLetterTRBL} is not a valid die orientation${position == null ? "" : ` at position ${position}`}.`);
        this.orientationAsLowercaseLetterTRBL = orientationAsLowercaseLetterTRBL;
    }
}
exports.InvalidFaceOrientationLettersTrblException = InvalidFaceOrientationLettersTrblException;
const FaceOrientationLetterTrbl = (faceOrientationLetterTrbl, position = {}) => {
    if (!isFaceOrientationLetterTrbl(faceOrientationLetterTrbl)) {
        throw new InvalidFaceOrientationLettersTrblException(faceOrientationLetterTrbl, position);
    }
    return faceOrientationLetterTrbl;
};
exports.FaceOrientationLetterTrbl = FaceOrientationLetterTrbl;
exports.FaceOrientationLetterTrbl.isValid = isFaceOrientationLetterTrbl;
exports.FaceOrientationLetterTrbl.toClockwise90DegreeRotationsFromUpright = (faceOrientationLetterTrbl) => ((((exports.FaceOrientationLettersTrbl.indexOf(faceOrientationLetterTrbl)) % 4)
    + 4) % 4 // ensure mod is positive even if using negative rotations
);
exports.FaceOrientationLettersTrblOrUnknown = [...exports.FaceOrientationLettersTrbl, "?"];
exports.ValidFaceOrientationLetterTrblOrUnknown = new Set(exports.FaceOrientationLettersTrblOrUnknown);
const isFaceOrientationLetterTrblOrUnknown = (c) => exports.ValidFaceOrientationLetterTrblOrUnknown.has(c);
class InvalidFaceOrientationLettersTrblOrUnknownException extends Error {
    constructor(orientationAsLowercaseLetterTRBL, { position } = {}) {
        super(`${orientationAsLowercaseLetterTRBL} is not a valid die orientation${position == null ? "" : ` at position ${position}`}.`);
        this.orientationAsLowercaseLetterTRBL = orientationAsLowercaseLetterTRBL;
    }
}
exports.InvalidFaceOrientationLettersTrblOrUnknownException = InvalidFaceOrientationLettersTrblOrUnknownException;
;
const FaceOrientationLetterTrblOrUnknown = (faceOrientationLetterTrblOrUnknown, position = {}) => {
    if (!isFaceOrientationLetterTrblOrUnknown(faceOrientationLetterTrblOrUnknown)) {
        throw new InvalidFaceOrientationLettersTrblOrUnknownException(faceOrientationLetterTrblOrUnknown, position);
    }
    return faceOrientationLetterTrblOrUnknown;
};
exports.FaceOrientationLetterTrblOrUnknown = FaceOrientationLetterTrblOrUnknown;
exports.FaceOrientationLetterTrblOrUnknown.isValid = isFaceOrientationLetterTrblOrUnknown;
exports.FaceOrientationLetterTrblOrUnknown.rotate = (faceOrientationLetterTrblOrUnknown, clockwise90DegreeRotations) => (!isFaceOrientationLetterTrbl(faceOrientationLetterTrblOrUnknown)) ? '?' :
    exports.FaceOrientationLettersTrbl[(((exports.FaceOrientationLettersTrbl.indexOf(faceOrientationLetterTrblOrUnknown) + clockwise90DegreeRotations) % 4) + 4) % 4 // ensure mod is positive even if using negative rotations
    ];
exports.FaceRotationLetterToClockwise90DegreeRotationsFromUpright = new Map(exports.FaceOrientationLettersTrbl.map((letter, index) => [letter, index]));
exports.FaceRotationLetterToClockwise90DegreeAngle = new Map(exports.FaceOrientationLettersTrbl.map((letter, index) => [letter, 90 * index]));
const faceRotationLetterToClockwiseAngle = (letter) => exports.FaceRotationLetterToClockwise90DegreeAngle.has(letter) ?
    exports.FaceRotationLetterToClockwise90DegreeAngle.get(letter) : 0;
exports.faceRotationLetterToClockwiseAngle = faceRotationLetterToClockwiseAngle;
/**
 * Coerce a string or digit into an Clockwise90DegreeRotationsFromUpright
 * @param digit The number (0-4) or string ('t','l','d','r') representing a rotation.  May not be '?'
 * @param param1 Optional objected used to pass a position for exception reporting
 */
const Clockwise90DegreeRotationsFromUpright = (rotation, { position } = {}) => {
    if (typeof rotation === "number") {
        if (rotation !== 0 && rotation % 90 === 0) {
            rotation = rotation / 90;
        }
        rotation = rotation % 4;
        return rotation;
    }
    if (!exports.FaceRotationLetterToClockwise90DegreeRotationsFromUpright.has(rotation)) {
        throw new InvalidFaceRotationException(rotation, { position });
    }
    return exports.FaceRotationLetterToClockwise90DegreeRotationsFromUpright.get(rotation);
};
exports.Clockwise90DegreeRotationsFromUpright = Clockwise90DegreeRotationsFromUpright;
exports.Clockwise90DegreeRotationsFromUpright.isValid = (candidate) => typeof (candidate) === "number" && candidate >= 0 && candidate <= 3;
//# sourceMappingURL=face.js.map